import { useHost } from './useHost';

/**
 * Hook to generate the correct URL for car images based on their path
 *
 * @param {string | null | undefined} imageUrl - The original image URL or path
 * @returns {string} The resolved complete image URL
 */
export const useCarImage = (imageUrl: string): string => {
  const { baseUrl, baseImageUrl } = useHost();

  // Handle empty strings
  if (!imageUrl) {
    return ''; // Return empty string when no image URL is provided
  }

  // Handle default image path
  if (imageUrl.startsWith('/default/')) {
    return `${baseImageUrl}/static${imageUrl}`;
  }

  // Handle absolute URLs
  if (/^https?:\/\//i.exec(imageUrl)) {
    return imageUrl;
  }

  // For relative URLs, prepend baseUrl, ensuring proper slash handling
  return baseUrl + (imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`);
};
